import { render, staticRenderFns } from "./PrestVariantDefault.vue?vue&type=template&id=37e4c5b1&scoped=true&"
import script from "./PrestVariantDefault.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PrestVariantDefault.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PrestVariantDefault.vue?vue&type=style&index=0&id=37e4c5b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4c5b1",
  null
  
)

export default component.exports